var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m9 .5 2.497 5.563 6.063.656-4.52 4.094 1.25 5.968L9 13.748l-5.29 3.033 1.25-5.968L.44 6.719l6.063-.656L9 .5Z",
  fill: "currentColor"
})));
export default SvgStar;